import SEOHead from "../components/SEOHead";
import Breadcrumbs from "../components/Breadcrumbs";

export default function MentionsLegalesPage() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Mentions légales | MarocPratique",
    url: "https://marocpratique.com/mentions-legales",
  };

  return (
    <>
      <SEOHead
        title="Mentions légales | MarocPratique"
        description="Mentions légales de MarocPratique.com : éditeur, hébergeur, responsabilité éditoriale et propriété intellectuelle."
        canonical="https://marocpratique.com/mentions-legales"
        jsonLd={jsonLd}
      />
      <div data-testid="mentions-legales-page" className="max-w-3xl mx-auto px-4 py-10">
        <Breadcrumbs
          items={[
            { label: "Accueil", href: "/" },
            { label: "Mentions légales" },
          ]}
        />
        <article className="prose prose-slate max-w-none mt-6">
          <h1 className="font-heading text-3xl font-bold text-slate-900 mb-6">
            Mentions légales
          </h1>

          <p className="text-slate-500 text-sm mb-8">Dernière mise à jour : Avril 2026</p>

          <h2>1. Éditeur du site</h2>
          <p>
            Le site <strong>MarocPratique.com</strong> est un site d'information et de conseils
            pratiques à destination des internautes marocains.
          </p>
          <p>
            Directeur de la publication : Éditeur de MarocPratique.com
            <br />
            Contact : via la page <a href="/contact">Contact</a>
          </p>

          <h2>2. Hébergement</h2>
          <p>
            Ce site est hébergé sur un serveur dédié (VPS). Pour toute demande liée à
            l'hébergement, contacter l'hébergeur via les coordonnées communiquées sur demande.
          </p>

          <h2>3. Propriété intellectuelle</h2>
          <p>
            L'ensemble du contenu de MarocPratique.com (textes, articles, organisation, mise en
            page) est la propriété exclusive de l'éditeur. Toute reproduction, même partielle,
            est soumise à autorisation préalable écrite.
          </p>
          <p>
            Les images utilisées proviennent de banques d'images libres de droits (Unsplash,
            Pexels) sous licence Creative Commons ou similaire.
          </p>

          <h2>4. Responsabilité éditoriale</h2>
          <p>
            Les informations publiées sur MarocPratique.com sont fournies à titre indicatif et
            informatif. Elles ne constituent pas un conseil juridique, fiscal ou médical.
          </p>
          <p>
            Les procédures administratives, prix et délais indiqués sont susceptibles d'évoluer.
            L'éditeur décline toute responsabilité en cas d'inexactitude ou d'évolution
            réglementaire. Consultez toujours les sources officielles (portail.maroc.ma,
            administration concernée) pour confirmer les informations.
          </p>

          <h2>5. Liens hypertextes</h2>
          <p>
            MarocPratique.com peut contenir des liens vers des sites tiers. Ces liens sont fournis
            à titre informatif. L'éditeur n'assume aucune responsabilité quant au contenu des
            sites liés.
          </p>

          <h2>6. Droit applicable</h2>
          <p>
            Le présent site est soumis au droit marocain. Tout litige relatif à son utilisation
            relève de la compétence exclusive des tribunaux marocains.
          </p>

          <h2>7. Indépendance et absence d'affiliation officielle</h2>
          <p>
            <strong>MarocPratique.com est un site éditorial indépendant.</strong> Il n'est affilié
            à aucune administration, ministère, collectivité territoriale, établissement public ou
            organisme officiel de l'État marocain. Le site ne représente pas l'État marocain, ni
            aucune autorité publique.
          </p>
          <p>
            Les contenus publiés ont pour unique objectif de faciliter la compréhension de
            démarches et d'informations pratiques disponibles publiquement. Ils ne remplacent pas
            les informations officielles délivrées par les administrations compétentes.
          </p>
          <p>
            Pour toute démarche administrative, il est impératif de vérifier les informations
            auprès des sources officielles : portail.maroc.ma, sites des ministères concernés,
            ou directement auprès de l'administration compétente.
          </p>

          <h2>8. Limitation de responsabilité</h2>
          <p>
            Les informations publiées sur MarocPratique.com sont fournies <strong>à titre
            indicatif et informatif</strong>. Malgré les efforts de vérification et de mise à
            jour régulière, des erreurs, omissions ou changements de procédure peuvent exister.
            Les administrations marocaines peuvent modifier leurs procédures, tarifs ou conditions
            à tout moment sans que MarocPratique.com en soit informé.
          </p>
          <p>
            <strong>L'utilisateur reste seul responsable</strong> de la vérification des
            informations auprès des sources officielles et de l'utilisation qu'il fait des
            contenus du site. MarocPratique.com ne saurait être tenu responsable d'une décision,
            démarche, perte, retard, erreur ou conséquence résultant de l'utilisation des
            informations publiées.
          </p>
          <p>
            Le site ne fournit pas de conseil juridique, fiscal, médical ou administratif
            officiel. Toute situation personnelle complexe doit être traitée avec un professionnel
            qualifié ou directement auprès de l'administration concernée.
          </p>
        </article>
      </div>
    </>
  );
}
